import { useEffect } from "react";
import { AffiliateTheme } from "./types";

/** Sets the document title and favicon for an affiliate, restoring both on unmount. */
export function useDocumentBranding(theme: AffiliateTheme | null, title?: string): void {
  useEffect(() => {
    if (!theme) {
      return;
    }

    const previousTitle = document.title;
    document.title = title ?? theme.name;

    let icon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    const previousHref = icon?.getAttribute("href") ?? null;
    let createdIcon = false;

    if (theme.faviconUrl) {
      if (!icon) {
        icon = document.createElement("link");
        icon.rel = "icon";
        document.head.appendChild(icon);
        createdIcon = true;
      }
      icon.href = theme.faviconUrl;
    }

    return () => {
      document.title = previousTitle;
      if (!icon || !theme.faviconUrl) {
        return;
      }
      if (createdIcon) {
        icon.remove();
      } else if (previousHref !== null) {
        icon.setAttribute("href", previousHref);
      }
    };
  }, [theme, title]);
}
